import ServerSystem from './ServerSystem';

const errors = {
	ServerSystem,
};

export default errors;



// WEBPACK FOOTER //
// ./src/errors/index.ts